import { jsx as x } from "react/jsx-runtime";
import { useMemo as B, useCallback as H, useEffect as P } from "react";
import { a as S, b as j, F as k } from "./chunks/index.esm-BFs3ABQ7.js";
import g from "./pruneFormData.js";
import { tv as w } from "tailwind-variants";
import N from "./Button.js";
const $ = ({
  className: n,
  isGhost: d,
  isWide: l,
  level: e = "primary",
  onClick: s,
  ...r
}) => {
  const {
    clearErrors: m,
    formState: u,
    getValues: t,
    reset: c,
    setFocus: F,
    setValue: f,
    trigger: i
  } = S(), p = { clearErrors: m, reset: c, setFocus: F, setValue: f, trigger: i };
  return /* @__PURE__ */ x(
    N,
    {
      className: n,
      isGhost: d,
      isWide: l,
      level: e,
      onClick: () => s && s(g(t()), u, p),
      ...r
    }
  );
}, M = w({
  base: ["flex", "flex-col", "gap-5", "text-neutral-900", "w-full"]
}), V = ({
  children: n,
  className: d,
  onBeforeValidate: l,
  onChange: e,
  onError: s,
  onSubmit: r
}) => {
  const m = j(), {
    clearErrors: u,
    formState: t,
    getValues: c,
    handleSubmit: F,
    reset: f,
    setFocus: i,
    setValue: p,
    trigger: v
  } = m, a = B(
    () => ({
      clearErrors: u,
      reset: f,
      setFocus: i,
      setValue: p,
      trigger: v
    }),
    [u, f, i, p, v]
  ), o = H(
    () => g(c()),
    [c]
  ), y = () => {
    r == null || r(o(), t, a);
  }, D = () => {
    s == null || s(o(), t, a);
  };
  return P(() => {
    e == null || e(o(), t, a);
  }, [a, t, o, e]), /* @__PURE__ */ x(k, { ...m, children: /* @__PURE__ */ x(
    "form",
    {
      className: M({ class: d }),
      noValidate: !0,
      onSubmit: (b) => {
        if (b.stopPropagation(), l ? l(o(), t, a) !== !1 : !0) return F(y, D)(b);
        b.preventDefault();
      },
      children: n
    }
  ) });
};
V.Button = $;
V.styles = M;
export {
  V as default
};
